import React, { Component } from 'react';
import { Button, Tooltip } from 'antd';
import { Link } from 'react-router-dom';
import GridView from '../../../components/elements/GridView/index';
import { FlagFilled, LocationFilled, NotificationFilled, PlugFilled } from '@carbon/icons-react';
import PropTypes from 'prop-types';
import { getPaginationTotal } from '../../../components/elements/GridView/GridViewBase/Pagination';
import moment from 'moment';
import Spinner from '../../../components/Spinner';

const { DB_DATE_FORMAT } = require('../../../core/constants').default;

class AssetEventHistoryTab extends Component {
    componentDidMount() {
        this.onPageChange(1, 10);
    }

    onPageChange = (page, pageSize) => {
        const { onPageChange } = this.props;

        onPageChange(page, pageSize);
    };

    onTableChange = (pagination, filters, sorter, extra) => {
        const { onTableChange, assetEventsPagination } = this.props;

        if (pagination && pagination.current === assetEventsPagination.currentPage) {
            onTableChange(pagination, filters, sorter, extra);
        }
    };

    render() {
        const {
            assetEvents,
            assetEventsPagination,
            isLoadingAssetEvents,
            isExportingAssetEventHistoryCsv,
            onExportAssetEventCSV,
            singleAsset,
        } = this.props;

        if (singleAsset && singleAsset.act_as_tracker) {
            return (
                <div className="h-centered-text-container">
                    <p>
                        Unavailable for this Asset — 
                        &thinsp;
                        <a 
                            href="https://www.fleetclear.com/contact" 
                            target="_blank" 
                            rel="noreferrer"
                        >
                            Click Here
                        </a> 
                        &thinsp;
                        to find out more
                    </p>
                </div>
            );
        }

        const listAssetEventHistory = assetEvents.map((event, eventIndex) => {
            const iconStyle = {};
            iconStyle.fontSize = '16px';
            iconStyle.color = '#CF2B28';
            iconStyle.verticalAlign = 'middle';
            const tempEvent = {};
            let eventTitle = event.event_name;
            if (event.event_type == 253) {
                if (event.green_driving_type == 0) {
                    eventTitle = 'Eco-friendly driving';
                } else if (event.green_driving_type == 1) {
                    eventTitle = 'Harsh accelerating';
                } else if (event.green_driving_type == 2) {
                    eventTitle = 'Harsh braking';
                } else if (event.green_driving_type == 3) {
                    eventTitle = 'Harsh cornering';
                }
            }
            tempEvent.event_type = (
                <Tooltip
                    placement="top"
                    title={eventTitle}
                >
                    <NotificationFilled
                        size={20}
                        style={{
                            color: 'var(--red)',
                            verticalAlign: 'middle',
                        }}
                    />
                    &ensp;
                    {event.event_name}
                </Tooltip>
            );
            if (event.icon && event.icon !== '') {
                switch (event.icon) {
                    case 'alert':
                    case 'bell':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                                <NotificationFilled
                                    size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                                />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                        );
                        break;
                    case 'api':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                                <PlugFilled
                                    size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                                />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                        );
                        break;
                    case 'environment':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                                <LocationFilled
                                    size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                                />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                        );
                        break;
                    case 'flag':
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                                <FlagFilled
                                    size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                                />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                        );
                        break;
                    default:
                        tempEvent.event_type = (
                            <Tooltip
                                placement="top"
                                title={eventTitle}
                            >
                                <NotificationFilled
                                    size={20}
                                    style={{
                                        color: 'var(--red)',
                                        verticalAlign: 'middle',
                                    }}
                                />
                                &ensp;
                                {event.event_name}
                            </Tooltip>
                        );
                }
            }
            tempEvent.date = moment(event.date, DB_DATE_FORMAT).format('DD/MM/YYYY');
            tempEvent.time = moment(event.time, 'hh:mm A').format('hh:mm A');
            tempEvent.location = event.location_name;
            tempEvent.driver = <Link to={`/drivers/view/${event.user_id}`}>{event.full_name}</Link>;
            tempEvent.asset_registration = event.registration;
            tempEvent.actions = (
                <Link
                    to={`/events/custom-view/${event.id}/${event.device_id}`}
                    className="btn-actions"
                >
                    View
                </Link>
            );
            return tempEvent;
        });

        return (
            <>
                <Spinner 
                    loading={isLoadingAssetEvents} 
                    minHeight={200}
                >
                    {assetEvents.length > 0 && (
                        <>
                            <Button
                                type="primary"
                                className="export-csv-button"
                                onClick={onExportAssetEventCSV}
                                style={{ marginBottom: '16px' }}
                                loading={isExportingAssetEventHistoryCsv}
                                data-testid='asset-details-events_export-btn'
                            >
                                Export
                            </Button>
                            <br/>
                        </>
                    )}
                    <div style={{ opacity: isLoadingAssetEvents ? 0 : 1 }}>
                        <GridView
                            data={listAssetEventHistory}
                            onChange={this.onTableChange}
                            sortableColumns={['event_type', 'date', 'time', 'location', 'driver', 'asset_registration']}
                            pagination={{
                                total: parseInt(assetEventsPagination.totalRecords, 10),
                                showSizeChanger: false,
                                pageSize: parseInt(assetEventsPagination.perPageCount, 10),
                                current: parseInt(assetEventsPagination.currentPage, 10),
                                onChange: this.onPageChange,
                                showTotal: getPaginationTotal,
                            }}
                        />
                    </div>
                </Spinner>
            </>
        );
    }
}

AssetEventHistoryTab.propTypes = {
    assetEvents: PropTypes.array,
    assetEventsPagination: PropTypes.shape({
        currentPage: PropTypes.number,
        perPageCount: PropTypes.number,
        totalRecords: PropTypes.number,
    }),
    isLoadingAssetEvents: PropTypes.bool,
    isExportingAssetEventHistoryCsv: PropTypes.bool,
    onExportAssetEventCSV: PropTypes.func.isRequired,
    onPageChange: PropTypes.func.isRequired,
    onTableChange: PropTypes.func.isRequired,
    singleAsset: PropTypes.object,
    eventHistoryTabLoaded: PropTypes.bool,
    setLoadedState: PropTypes.func,
};

AssetEventHistoryTab.defaultProps = {
    assetEvents: [],
    assetEventsPagination: { currentPage: 1, perPageCount: 10, totalRecords: 0 },
    isLoadingAssetEvents: false,
    isExportingAssetEventHistoryCsv: false,
    singleAsset: {},
    eventHistoryTabLoaded: false,
    setLoadedState: () => {},
};

export default AssetEventHistoryTab;
